import { useState } from "react";
import { Dialog, DialogTitle, DialogActions, DialogContent, Button, TextField } from "@mui/material";
import { InputFieldContainer } from "./styles";
import { DialogProps } from "../../data";


const MoveInterchangeDialog = (props: DialogProps) => {
  const {open, interchange, onClose, onAction} = props;

  const [bookingNumber, setBookingNumber] = useState<string>("");
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true);

  const handleSubmit = () => {
    onAction(interchange.id, bookingNumber)
  }

  const handleBookingNumberChange = (e: any) => {
    const orderNumber = e?.target?.value?.replace(/\D/g, "") ?? "";

    setBookingNumber(orderNumber);

    if(orderNumber && orderNumber !== interchange?.orderNumber) {
      setDisableSubmit(false)
    } else setDisableSubmit(true)
  }

  return <Dialog open={open}>
    <DialogTitle>Move Interchange</DialogTitle>
    <DialogContent>
      <InputFieldContainer>
        <TextField label="Booking Number" value={bookingNumber} onChange={handleBookingNumberChange}/>
      </InputFieldContainer>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button disabled={disableSubmit} onClick={handleSubmit}>Confirm</Button>
    </DialogActions>
  </Dialog>
};

export default MoveInterchangeDialog;